module.exports = __webpack_public_path__ + "static/media/logo_putri_colored.637de996.png";